export default __webpack_public_path__ + "static/media/Litto-1Open.4991196b.jpg";